import React, { useEffect, useState } from "react";
import { Button, Grid, Stack, Switch, TextField } from "@mui/material";
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useDate } from "../../../../../helpers/hooks/custom/useDate";
import { useCheck } from "../../../../../helpers/hooks/custom/useCheck";
import { UpdateScheduledGlobal } from "../usecases/UpdateScheduledGlobal";
import { useFetchScheduled } from "../../../../../helpers/hooks/fetch/useFetchScheduled";
import { formatterTimePicker } from "../../../../../helpers/date/formatterTimePicker";
import { UpdateScheduledDaily } from "../usecases/UpdateScheduledDaily";
import { dateFormat, timeFormat } from "../../../../../helpers/date/date";
import SnackBar from "../../../../../components/snackbar/SnackBar";
import { useField } from "../../../../../helpers/hooks/custom/useField";

const ScheduledJob = () => {
  const settings = useFetchScheduled();
  const jobs = useCheck({ value: false });
  const dailyJobs = useCheck({ value: false });
  const timeLapse = useField({ type: "number", name: "timeLapse" });
  const dailyLapse = useField({ type: "number", name: "dailyLapse" });
  const dateStart = useDate({ type: "text", name: "dateStart" });
  const timeStart = useDate({ type: "text", name: "timeStart" });
  const dateEnd = useDate({ type: "text", name: "dateEnd" });
  const timeEnd = useDate({ type: "text", name: "timeEnd" });
  const dailyStart = useDate({ type: "text", name: "dailyStart" });
  const dailyEnd = useDate({ type: "text", name: "dailyEnd" });

  const riderJobs = useCheck({ value: false });
  const riderDailyJobs = useCheck({ value: false });
  const riderTimeLapse = useField({ type: "number", name: "timeLapse" });
  const riderDailyLapse = useField({ type: "number", name: "dailyLapse" });
  const riderDateStart = useDate({ type: "text", name: "dateStart" });
  const riderTimeStart = useDate({ type: "text", name: "timeStart" });
  const riderDateEnd = useDate({ type: "text", name: "dateEnd" });
  const riderTimeEnd = useDate({ type: "text", name: "timeEnd" });
  const riderDailyStart = useDate({ type: "text", name: "dailyStart" });
  const riderDailyEnd = useDate({ type: "text", name: "dailyEnd" });

  const vertical = "top";
  const horizontal = "center";
  const [messageSnk, setMessageSnk] = useState("");
  const [stateSnk, setStateSnk] = useState(false);
  const [severity, setSeverity] = useState("success");

  const handleSnkClose = () => setStateSnk(false);

  const snackBarDialog = (message, severity = "success") => {
    setMessageSnk(message);
    setSeverity(severity);
    setStateSnk(true);
  };

  useEffect(() => {
    if (settings.value) {
      const isGlobal = Boolean(settings.value.global);
      const isDaily = Boolean(settings.value.daily);
      const global = { target: { checked: isGlobal } };
      const daily = { target: { checked: isDaily } };
      jobs.onChange(global);
      dailyJobs.onChange(daily);

      if (settings.value.date_issue) {
        const dateIssue = dayjs(
          settings.value.date_issue,
          "DD/MM/YYYY"
        ).toDate();
        dateStart.onChange(dateIssue);
      }
      if (settings.value.time_expire) {
        const timeIssue = formatterTimePicker(
          settings.value.date_issue,
          settings.value.time_issue
        );
        timeStart.onChange(timeIssue);
      }
      if (settings.value.date_expire) {
        const dateExpire = dayjs(
          settings.value.date_expire,
          "DD/MM/YYYY"
        ).toDate();
        dateEnd.onChange(dateExpire);
      }
      if (settings.value.time_expire) {
        const timeExpire = formatterTimePicker(
          settings.value.date_expire,
          settings.value.time_expire
        );
        timeEnd.onChange(timeExpire);
      }

      timeLapse.onChange({ target: { value: settings.value.time_lapse } });
      if (settings.value.daily_start) {
        const start = formatterTimePicker(
          "1/11/2021",
          settings.value.daily_start
        );
        dailyStart.onChange(start);
      }
      if (settings.value.daily_end) {
        const end = formatterTimePicker("01/11/2021", settings.value.daily_end);
        dailyEnd.onChange(end);
      }
      dailyLapse.onChange({ target: { value: settings.value.daily_lapse } });
    }
    if (settings.rider) {
      const isGlobal = Boolean(settings.rider.global);
      const isDaily = Boolean(settings.rider.daily);
      const global = { target: { checked: isGlobal } };
      const daily = { target: { checked: isDaily } };
      riderJobs.onChange(global);
      riderDailyJobs.onChange(daily);

      if (settings.rider.date_issue) {
        const dateIssue = dayjs(
          settings.rider.date_issue,
          "DD/MM/YYYY"
        ).toDate();
        riderDateStart.onChange(dateIssue);
      }
      if (settings.rider.time_expire) {
        const timeIssue = formatterTimePicker(
          settings.rider.date_issue,
          settings.rider.time_issue
        );
        riderTimeStart.onChange(timeIssue);
      }
      if (settings.rider.date_expire) {
        const dateExpire = dayjs(
          settings.rider.date_expire,
          "DD/MM/YYYY"
        ).toDate();
        riderDateEnd.onChange(dateExpire);
      }
      if (settings.rider.time_expire) {
        const timeExpire = formatterTimePicker(
          settings.rider.date_expire,
          settings.rider.time_expire
        );
        riderTimeEnd.onChange(timeExpire);
      }

      riderTimeLapse.onChange({ target: { value: settings.rider.time_lapse } });
      
      if (settings.rider.daily_start) {
        const start = formatterTimePicker(
          "1/11/2021",
          settings.rider.daily_start
        );
        riderDailyStart.onChange(start);
      }
      if (settings.rider.daily_end) {
        const end = formatterTimePicker("01/11/2021", settings.rider.daily_end);
        riderDailyEnd.onChange(end);
      }
      riderDailyLapse.onChange({
        target: { value: settings.rider.daily_lapse },
      });
    }
  }, [settings.value, settings.rider]);

  const validateGlobal = () => {
    if (!jobs.checked) return true;

    if (dateStart.value === "")
      return snackBarDialog("INGRESE FECHA INICIAL", "error");
    if (timeStart.value === "")
      return snackBarDialog("INGRESE HORA INICIAL", "error");
    if (dateEnd.value === "")
      return snackBarDialog("INGRESE FECHA FIN", "error");
    if (timeEnd.value === "")
      return snackBarDialog("INGRESE HORA FIN", "error");

    return true;
  };

  const validateDaily = () => {
    if (!dailyJobs.checked) return true;

    if (dailyStart.value === "")
      return snackBarDialog("INGRESE HORA INICIO", "error");
    if (dailyEnd.value === "")
      return snackBarDialog("INGRESE HORA FIN", "error");

    return true;
  };

  const handleScheduledJob = async (e) => {
    e.preventDefault();
    if (validateGlobal()) {
      const data = {
        id: 1,
        global: jobs.checked,
        dateStart: dateStart.value != "" ? dateEval(dateStart) : "",
        timeStart: timeStart.value != "" ? timeEval(timeStart) : "",
        dateEnd: dateEnd.value != "" ? dateEval(dateEnd) : "",
        timeEnd: timeEnd.value != "" ? timeEval(timeEnd) : "",
        lapse: timeLapse.value,
      };
      const resp = await UpdateScheduledGlobal(data);
      if (resp.message === "SUCCESS")
        return snackBarDialog("SE HAN GUARDADO LOS CAMBIOS");
      else return snackBarDialog("ERROR, NO SE LOGRO ACTUALIZAR", "error");
    }
  };

  const handleDailyJobs = async (e) => {
    e.preventDefault();
    if (validateDaily()) {
      const data = {
        id: 1,
        daily: dailyJobs.checked,
        start: dailyStart.value != "" ? timeEval(dailyStart) : "",
        end: dailyEnd.value != "" ? timeEval(dailyEnd) : "",
        lapse: dailyLapse.value,
      };
      const resp = await UpdateScheduledDaily(data);
      if (resp.message === "SUCCESS") {
        return snackBarDialog("SE HAN GUARDADO LOS CAMBIOS");
      } else {
        return snackBarDialog("ERROR, NO SE LOGRO ACTUALIZAR", "error");
      }
    }
  };

  const handleRiderScheduledJob = async (e) => {
    e.preventDefault();
    if (validateGlobal()) {
      const data = {
        id: 2,
        global: riderJobs.checked,
        dateStart: riderDateStart.value != "" ? dateEval(dateStart) : "",
        timeStart: riderTimeStart.value != "" ? timeEval(timeStart) : "",
        dateEnd: riderDateEnd.value != "" ? dateEval(dateEnd) : "",
        timeEnd: riderTimeEnd.value != "" ? timeEval(timeEnd) : "",
        lapse: riderTimeLapse.value,
      };
      const resp = await UpdateScheduledGlobal(data);
      if (resp.message === "SUCCESS")
        return snackBarDialog("SE HAN GUARDADO LOS CAMBIOS");
      else return snackBarDialog("ERROR, NO SE LOGRO ACTUALIZAR", "error");
    }
  };

  const handleRiderDailyJobs = async (e) => {
    e.preventDefault();
    if (validateDaily()) {
      const data = {
        id: 2,
        daily: riderDailyJobs.checked,
        start: riderDailyStart.value != "" ? timeEval(riderDailyStart) : "",
        end: riderDailyEnd.value != "" ? timeEval(riderDailyEnd) : "",
        lapse: riderDailyLapse.value,
      };
      const resp = await UpdateScheduledDaily(data);
      if (resp.message === "SUCCESS") {
        return snackBarDialog("SE HAN GUARDADO LOS CAMBIOS");
      } else {
        return snackBarDialog("ERROR, NO SE LOGRO ACTUALIZAR", "error");
      }
    }
  };

  const timeEval = (timeData) => {
    return timeData?.value?.$d
      ? timeFormat(timeData.value.$d)
      : timeFormat(timeData.value);
  };
  const dateEval = (dateData) => {
    return dateData?.value?.$d
      ? dateFormat(dateData.value.$d)
      : dateFormat(dateData.value);
  };

  useEffect(() => {
    if (jobs.datable) {
      const current = new Date();
      const dd = dateFormat(current);
      const tt = timeFormat(current);

      const newDate = new Date(current);
      newDate.setDate(newDate.getDate() + 5);

      const dateIssue = dayjs(dd, "DD/MM/YYYY").toDate();
      dateStart.onChange(dateIssue);
      const timeIssue = formatterTimePicker(dd, tt);
      timeStart.onChange(timeIssue);

      const ddE = dateFormat(newDate);
      const ttE = timeFormat(newDate);
      const dateExpire = dayjs(ddE, "DD/MM/YYYY").toDate();
      dateEnd.onChange(dateExpire);
      const timeExpire = formatterTimePicker(ddE, ttE);
      timeEnd.onChange(timeExpire);
    }
    if (dailyJobs.datable) {
      const current = new Date();
      const dd = dateFormat(current);
      const tt = timeFormat(current);
      const start = formatterTimePicker(dd, tt);
      dailyStart.onChange(start);

      const newDate = new Date(current);
      newDate.setHours(newDate.getHours() + 12);
      const ddE = dateFormat(newDate);
      const ttE = timeFormat(newDate);
      const end = formatterTimePicker(ddE, ttE);
      dailyEnd.onChange(end);
    }
  }, [jobs.checked, dailyJobs.checked]);

  useEffect(() => {
    if (riderJobs.datable) {
      const current = new Date();
      const dd = dateFormat(current);
      const tt = timeFormat(current);

      const newDate = new Date(current);
      newDate.setDate(newDate.getDate() + 5);

      const dateIssue = dayjs(dd, "DD/MM/YYYY").toDate();
      riderDateStart.onChange(dateIssue);
      const timeIssue = formatterTimePicker(dd, tt);
      riderTimeStart.onChange(timeIssue);

      const ddE = dateFormat(newDate);
      const ttE = timeFormat(newDate);
      const dateExpire = dayjs(ddE, "DD/MM/YYYY").toDate();
      riderDateEnd.onChange(dateExpire);
      const timeExpire = formatterTimePicker(ddE, ttE);
      riderTimeEnd.onChange(timeExpire);
    }

    if (riderDailyJobs.datable) {
      const current = new Date();
      const dd = dateFormat(current);
      const tt = timeFormat(current);
      const start = formatterTimePicker(dd, tt);
      riderDailyStart.onChange(start);

      const newDate = new Date(current);
      newDate.setHours(newDate.getHours() + 12);
      const ddE = dateFormat(newDate);
      const ttE = timeFormat(newDate);
      const end = formatterTimePicker(ddE, ttE);
      riderDailyEnd.onChange(end);
    }
  }, [riderJobs.checked, riderDailyJobs.checked]);

  return (
    <div style={{ padding: 4, marginBottom: "1em" }}>
      <p>HORARIOS AUTOMATICOS</p>

      <div style={{ border: "1px solid white", padding: "1px 2px 10px 0" }}>
        <Grid container spacing={1}>
          <Grid item xs={12} textAlign={"center"}>
            <p>EMPRESAS</p>
          </Grid>

          <Grid item xs={6} sm={1} textAlign={"center"}>
            <label>FECHA:</label>
            <Switch
              checked={jobs.checked}
              onChange={jobs.onChange}
              color="secondary"
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid>

          <Grid item xs={6} sm={1}>
            <TextField
              {...timeLapse}
              fullWidth
              label="TIEMPO"
              disabled={!jobs.checked}
            />
          </Grid>

          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileDatePicker
                  label={"Fecha Inicio"}
                  inputFormat="DD/MM/YYYY"
                  {...dateStart}
                  disabled={!jobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileTimePicker
                  label={"Hora Inicio"}
                  {...timeStart}
                  disabled={!jobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileDatePicker
                  label={"Fecha Fin"}
                  inputFormat="DD/MM/YYYY"
                  {...dateEnd}
                  disabled={!jobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileTimePicker
                  label={"Hora Fin"}
                  {...timeEnd}
                  disabled={!jobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="success"
              sx={{ height: "50px" }}
              fullWidth
              onClick={handleScheduledJob}
            >
              GUARDAR
            </Button>
          </Grid>

          <Grid item xs={6} sm={1} textAlign={"center"}>
            <label>DIARIAS</label>
            <Switch
              checked={dailyJobs.checked}
              onChange={dailyJobs.onChange}
              color="secondary"
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid>
          <Grid item xs={6} sm={1}>
            <TextField
              {...dailyLapse}
              fullWidth
              label="TIEMPO"
              disabled={!dailyJobs.checked}
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileTimePicker
                  label={"Hora Inicio"}
                  {...dailyStart}
                  disabled={!dailyJobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileTimePicker
                  label={"Hora Fin"}
                  {...dailyEnd}
                  disabled={!dailyJobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="success"
              sx={{ height: "50px" }}
              fullWidth
              onClick={handleDailyJobs}
            >
              GUARDAR
            </Button>
          </Grid>
        </Grid>
      </div>

      <div style={{ border: "1px solid white", padding: "1px 2px 10px 0" }}>
        <Grid container spacing={1}>
          <Grid item xs={12} textAlign={"center"}>
            <p>CLIENTES</p>
          </Grid>
          <Grid item xs={6} sm={1} textAlign={"center"}>
            <label>FECHA:</label>
            <Switch
              checked={riderJobs.checked}
              onChange={riderJobs.onChange}
              color="secondary"
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid>

          <Grid item xs={6} sm={1}>
            <TextField
              {...riderTimeLapse}
              fullWidth
              label="TIEMPO"
              disabled={!riderJobs.checked}
            />
          </Grid>

          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileDatePicker
                  label={"Fecha Inicio"}
                  inputFormat="DD/MM/YYYY"
                  {...riderDateStart}
                  disabled={!riderJobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileTimePicker
                  label={"Hora Inicio"}
                  {...riderTimeStart}
                  disabled={!riderJobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileDatePicker
                  label={"Fecha Fin"}
                  inputFormat="DD/MM/YYYY"
                  {...riderDateEnd}
                  disabled={!riderJobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileTimePicker
                  label={"Hora Fin"}
                  {...riderTimeEnd}
                  disabled={!riderJobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="success"
              sx={{ height: "50px" }}
              fullWidth
              onClick={handleRiderScheduledJob}
            >
              GUARDAR
            </Button>
          </Grid>

          <Grid item xs={6} sm={1} textAlign={"center"}>
            <label>DIARIAS</label>
            <Switch
              checked={riderDailyJobs.checked}
              onChange={riderDailyJobs.onChange}
              color="secondary"
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid>
          <Grid item xs={6} sm={1}>
            <TextField
              {...riderDailyLapse}
              fullWidth
              label="TIEMPO"
              disabled={!riderDailyJobs.checked}
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileTimePicker
                  label={"Hora Inicio"}
                  {...riderDailyStart}
                  disabled={!riderDailyJobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileTimePicker
                  label={"Hora Fin"}
                  {...riderDailyEnd}
                  disabled={!riderDailyJobs.checked}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="success"
              sx={{ height: "50px" }}
              fullWidth
              onClick={handleRiderDailyJobs}
            >
              GUARDAR
            </Button>
          </Grid>
        </Grid>
      </div>
      <SnackBar
        stateSnk={stateSnk}
        vertical={vertical}
        horizontal={horizontal}
        duration={4000}
        handleClose={handleSnkClose}
        severity={severity}
        messageSnk={messageSnk}
      />
    </div>
  );
};

export default ScheduledJob;
